export default {
    LOADING (state) {
        state.loading++;
    },
    LOADED (state) {
        state.loading--;
    },
    SET_TRANSLATIONS(state, data) {
        state.translations = {...data};       
    }
}